import { useState, useEffect, useCallback } from 'react';
import { useAuthFetch } from '../hooks/useAuthFetch';

const is = { width: '100%', padding: '9px 11px', borderRadius: 7, background: '#0f1117', border: '1px solid #2a2d3e', color: '#e2e8f0', fontSize: 13, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' };

const ROLES = ['admin', 'commercial'];

function UserModal({ user, onClose, onSave }) {
  const fetchWithAuth = useAuthFetch();
  const isEdit = !!user;
  const [form, setForm] = useState({
    login: user?.login || '',
    nom: user?.nom || '',
    prenom: user?.prenom || '',
    email: user?.email || '',
    role: user?.role || 'commercial',
    actif: user?.actif !== undefined ? user.actif : 1,
    password: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEdit && !form.login) { setError('Login requis'); return; }
    if (!isEdit && !form.password) { setError('Mot de passe requis'); return; }
    setSaving(true); setError('');
    try {
      const body = isEdit
        ? { nom: form.nom, prenom: form.prenom, email: form.email, role: form.role, actif: form.actif, ...(form.password ? { password: form.password } : {}) }
        : { login: form.login, password: form.password, nom: form.nom, prenom: form.prenom, email: form.email, role: form.role };
      const res = await fetchWithAuth(
        isEdit ? `/api/auth/users/${user.id}` : '/api/auth/users',
        { method: isEdit ? 'PUT' : 'POST', body: JSON.stringify(body) }
      );
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      onSave();
      onClose();
    } finally { setSaving(false); }
  };

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 300 }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 420, background: '#1a1d2e', border: '1px solid #2a2d3e', borderRadius: 14, padding: 28, zIndex: 301, boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#e2e8f0' }}>{isEdit ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>

        {error && <div style={{ background: '#ef444420', border: '1px solid #ef444440', borderRadius: 8, padding: '8px 12px', color: '#ef4444', fontSize: 13, marginBottom: 14 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-grid" style={{ marginBottom: 0 }}>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 4 }}>Prénom</label>
              <input value={form.prenom} onChange={e => setForm(f => ({ ...f, prenom: e.target.value }))} style={is} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 4 }}>Nom</label>
              <input value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} style={is} />
            </div>
          </div>

          {!isEdit && (
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 4 }}>Login *</label>
              <input value={form.login} onChange={e => setForm(f => ({ ...f, login: e.target.value }))} placeholder="ex: jean.dupont" style={is} required />
            </div>
          )}

          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 4 }}>Email</label>
            <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={is} />
          </div>

          <div className="form-grid" style={{ marginBottom: 12 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 4 }}>Rôle</label>
              <select value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))} style={{ ...is, cursor: 'pointer' }}>
                {ROLES.map(r => <option key={r} value={r}>{r === 'admin' ? 'Administrateur' : 'Commercial'}</option>)}
              </select>
            </div>
            {isEdit && (
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 4 }}>Statut</label>
                <select value={form.actif} onChange={e => setForm(f => ({ ...f, actif: Number(e.target.value) }))} style={{ ...is, cursor: 'pointer' }}>
                  <option value={1}>Actif</option>
                  <option value={0}>Inactif</option>
                </select>
              </div>
            )}
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 4 }}>{isEdit ? 'Nouveau mot de passe (laisser vide = inchangé)' : 'Mot de passe *'}</label>
            <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••" style={is} />
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button type="submit" disabled={saving} style={{ flex: 1, padding: '10px', borderRadius: 8, background: saving ? '#35956aaa' : '#41B073', border: 'none', color: '#fff', fontWeight: 600, fontSize: 14, cursor: saving ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
              {saving ? '...' : isEdit ? 'Enregistrer' : 'Créer'}
            </button>
            <button type="button" onClick={onClose} style={{ padding: '10px 18px', borderRadius: 8, background: 'transparent', border: '1px solid #2a2d3e', color: '#64748b', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}>Annuler</button>
          </div>
        </form>
      </div>
    </>
  );
}

export default function AdminPage() {
  const fetchWithAuth = useAuthFetch();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editUser, setEditUser] = useState(null);
  const [showCreate, setShowCreate] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchWithAuth('/api/auth/users');
      const data = await res.json();
      setUsers(data);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const deleteUser = async (user) => {
    if (!window.confirm(`Supprimer ${user.prenom} ${user.nom} ?`)) return;
    await fetchWithAuth(`/api/auth/users/${user.id}`, { method: 'DELETE' });
    load();
  };

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#e2e8f0' }}>Administration</h1>
          <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: 13 }}>Gestion des utilisateurs</p>
        </div>
        <button onClick={() => setShowCreate(true)} style={{ padding: '9px 18px', borderRadius: 8, background: '#41B073', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' }}>
          + Nouvel utilisateur
        </button>
      </div>

      <div style={{ background: '#1a1d2e', border: '1px solid #2a2d3e', borderRadius: 10, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Chargement...</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #2a2d3e' }}>
                {['Utilisateur', 'Login', 'Email', 'Rôle', 'Statut', ''].map(h => (
                  <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 11, color: '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr><td colSpan={6} style={{ padding: 30, textAlign: 'center', color: '#64748b' }}>Aucun utilisateur</td></tr>
              ) : users.map((u, i) => (
                <tr key={u.id} style={{ borderBottom: '1px solid #2a2d3e', background: i % 2 === 0 ? 'transparent' : '#ffffff05' }}>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#e2e8f0' }}>{u.prenom} {u.nom}</div>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: '#94a3b8', fontFamily: 'DM Mono, monospace' }}>{u.login}</td>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: '#94a3b8' }}>{u.email || '—'}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: u.role === 'admin' ? '#41B07322' : '#3b82f622', color: u.role === 'admin' ? '#41B073' : '#3b82f6', border: `1px solid ${u.role === 'admin' ? '#41B07344' : '#3b82f644'}` }}>
                      {u.role === 'admin' ? 'Administrateur' : 'Commercial'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: u.actif ? '#22c55e22' : '#ef444422', color: u.actif ? '#22c55e' : '#ef4444', border: `1px solid ${u.actif ? '#22c55e44' : '#ef444444'}` }}>
                      {u.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => setEditUser(u)} style={{ padding: '5px 12px', borderRadius: 6, background: 'transparent', border: '1px solid #41B07340', color: '#41B073', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}>
                        Modifier
                      </button>
                      <button onClick={() => deleteUser(u)} style={{ padding: '5px 12px', borderRadius: 6, background: 'transparent', border: '1px solid #ef444440', color: '#ef4444', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}>
                        Supprimer
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showCreate && <UserModal onClose={() => setShowCreate(false)} onSave={load} />}
      {editUser && <UserModal user={editUser} onClose={() => setEditUser(null)} onSave={load} />}
    </div>
  );
}
